/** Query param that enables programmatic syllabus PDF download on `/syllabus/<key>`. */
export const SYLLABUS_AUTO_DOWNLOAD_QUERY_KEY = 'download';

/** Only this exact string value enables auto-download. */
export const SYLLABUS_AUTO_DOWNLOAD_QUERY_VALUE = '1';

export function buildSyllabusUrlWithAutoDownload(programKey: string): string {
  const params = new URLSearchParams({ [SYLLABUS_AUTO_DOWNLOAD_QUERY_KEY]: SYLLABUS_AUTO_DOWNLOAD_QUERY_VALUE });
  return `/syllabus/${programKey}?${params.toString()}`;
}
